import { Action } from '@ngrx/store';
import { UserModel } from '../../../customer/models/UserModel';

export const GET_CURRENT_USER_SUCCESS = '[Security] Get Current User Success';

export class GetCurrentUserProfileSuccessAction implements Action {
  readonly type = GET_CURRENT_USER_SUCCESS;

  constructor(public payload: UserModel) {}
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/GetCurrentUserProfileSuccessAction.ts